export const USER_ID_COOKIE_NAME = 'meteor_user_id_insecure' as const;
